import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MyContext } from "../Context/MyContext";
import PageLoadGate from "../Components/Skeleton/PageLoadGate";
import { FormPageSkeleton } from "../Components/Skeleton/Skeleton";
import "./EmiCalculator.css";
import "./WarrantyPolicy.css";

export default function WarrantyPolicy() {
  const { warranty_page: page } = useContext(MyContext);
  const navigate = useNavigate();
  const heroCta = page.heroCta || {};
  const policy = page.policy || {};

  return (
    <PageLoadGate skeleton={<FormPageSkeleton />} delay={380}>
      <div className="warranty-page">
        <div className="warranty-hero">
          <div className="warranty-hero-inner">
            <span className="warranty-badge">{page.badge}</span>
            <h1>{page.title}</h1>
            <p>{page.subtitle}</p>
            <div className="warranty-hero-actions">
              <button
                type="button"
                className="warranty-btn primary"
                onClick={() => navigate(heroCta.browsePath || "/cars")}
              >
                {heroCta.browseLabel}
              </button>
              <button
                type="button"
                className="warranty-btn secondary"
                onClick={() => navigate(heroCta.contactPath || "/contact")}
              >
                {heroCta.contactLabel}
              </button>
            </div>
          </div>
        </div>

        <div className="warranty-body">
          <div className="warranty-layout">
            <section className="warranty-plans-section">
              <h2>Protection Plans</h2>
              <div className="warranty-plans-grid">
                {(page.plans || []).map((plan) => (
                  <article key={plan.id} className="warranty-plan-card">
                    {plan.badge && <span className="warranty-plan-badge">{plan.badge}</span>}
                    <h3>{plan.name}</h3>
                    <p className="warranty-plan-note">{plan.priceNote}</p>
                    <ul>
                      {(plan.highlights || []).map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                    <div className="warranty-plan-meta">
                      {plan.returnDays > 0 && (
                        <span>{plan.returnDays}-day return</span>
                      )}
                      {plan.supportDays > 0 && (
                        <span>{plan.supportDays}-day support</span>
                      )}
                      {plan.engineGearbox && <span>Engine & gearbox</span>}
                    </div>
                  </article>
                ))}
              </div>
            </section>

            <section className="warranty-policy-section">
              <h2>{policy.title}</h2>
              {(policy.sections || []).map((section) => (
                <div key={section.id} className="warranty-policy-block">
                  <h3>{section.title}</h3>
                  {section.points && (
                    <ul>
                      {section.points.map((point) => (
                        <li key={point}>{point}</li>
                      ))}
                    </ul>
                  )}
                  {section.steps && (
                    <ol className="warranty-steps">
                      {section.steps.map((step) => (
                        <li key={step.step}>
                          <strong>
                            {step.step}. {step.title}
                          </strong>
                          <p>{step.description}</p>
                        </li>
                      ))}
                    </ol>
                  )}
                </div>
              ))}
            </section>

            <section className="warranty-lifecycle-section">
              <h2>{page.order?.lifecycleTitle || "Order Lifecycle"}</h2>
              <p className="warranty-lifecycle-sub">
                {page.order?.lifecycleSubtitle ||
                  "Track your protection request through each stage"}
              </p>
              <div className="warranty-lifecycle-track">
                {(page.order?.lifecycle || []).map((step, index) => (
                  <div key={step.status} className="warranty-lifecycle-step">
                    <span className="warranty-step-num">{index + 1}</span>
                    <div>
                      <strong>{step.label}</strong>
                      <p>{step.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <div className="warranty-footer-cta">
              <Link to="/cars" className="warranty-btn primary">
                {heroCta.browseLabel}
              </Link>
              <Link to="/finance" className="warranty-btn ghost">
                Calculate EMI
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PageLoadGate>
  );
}
